import { tv } from 'tailwind-variants';
import { CARD_ROOT_REFLOW } from '@/components/shared/LessonOverview/Cards/reflowStyles';
import styles from './TeacherCard.module.scss';

const teacherCardStyles = tv({
  slots: {
    header: styles.header,
    root: ['card', styles.card],
    title: styles.title,
  },
  variants: {
    reflow: {
      true: {
        header: 'tw-h-auto tw-min-h-[5.3125rem] tw-flex-wrap reflow-narrow:tw-h-[85px] reflow-narrow:tw-min-h-0 reflow-narrow:tw-flex-nowrap',
        root: CARD_ROOT_REFLOW,
        title: 'tw-w-full tw-max-w-[11.5625rem] tw-float-none reflow-narrow:tw-w-[185px] reflow-narrow:tw-max-w-none reflow-narrow:tw-float-left',
      },
    },
  },
});

export default teacherCardStyles;
